import React from 'react';
import { FadeIn } from './FadeIn';
import { trackPixelEvent } from '../lib/metaPixel';
export function FinalCTASection() {
  return <section className="py-24 bg-brand-forest text-white text-center relative overflow-hidden" data-id="element-28" data-mp="3n1i7ktli46cj">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-29" data-mp="vv11t3xi4k6">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-brand-sage rounded-full blur-3xl" data-id="element-30" data-mp="2zdqydyv9c9fh"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-brand-sage rounded-full blur-3xl" data-id="element-31" data-mp="34cbv3obawaz6"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-32" data-mp="39bevgvgc5t0t">
        <FadeIn data-id="element-33" data-mp="3e2eo3oif9oxi">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-34" data-mp="3e2wtpbqz5fi3">
            Tu mente no necesita más presión.
            <br data-id="element-35" data-mp="2gmhjfa2pwsgi" />
            Necesita menos ruido
            <br data-id="element-36" data-mp="2llkgo8cghudx" />
            y un plan claro.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-37" data-mp="2ljrbkxhhri81">
          <p className="text-xl md:text-2xl text-brand-sage italic mb-12 font-serif" data-id="element-38" data-mp="26vafbw8hdqva">
            21 días. 3 fases. Herramientas prácticas con referencias
            científicas.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-39" data-mp="1x461izujkc21">
          <a href="https://pay.hotmart.com/P106181864L?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('AddToCart', {
          content_name: 'Desintoxica tu Mente en 21 Días',
          content_type: 'product',
          currency: 'USD',
          value: 19.99
        })} className="inline-block text-center bg-brand-terracotta text-white px-8 py-4 rounded-full text-lg md:text-xl font-bold hover:bg-opacity-90 hover:scale-105 transition-all duration-300 shadow-xl mb-10 w-full sm:w-auto" data-id="element-40" data-mp="1x3ehmmab42rl">
            QUIERO MI GUÍA AHORA — $19.99 →
          </a>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-41" data-mp="11wdvxpg9fr19">
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium" data-id="element-42" data-mp="11v2rdnezqf93">
            <div className="flex items-center gap-2" data-id="element-43" data-mp="16nc9wids0d1c">
              <span data-id="element-44" data-mp="16ox9imey6m62">🔒</span> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-45" data-mp="ryzd5j6v6q5s">
              <span data-id="element-46" data-mp="wx0x06c46tib">📥</span> Descarga Inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-47" data-mp="wxkdrjq13bur">
              <span data-id="element-48" data-mp="1km3p684dk4r2">🧠</span> Incluye referencias científicas
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}